import { storageFileUrl } from './storage-file-url';

export interface UploadFileDto {
  readonly id: string;
  readonly pathToFileInStorage?: string;
  readonly contentHash?: string;
  readonly viewSettings?: { readonly width?: number; readonly height?: number };
  readonly exifData?: { readonly imageDominantColor?: string; readonly thumbHash?: string; readonly rating?: number };
  readonly storageInfo?: { readonly storageStaticEndpoint?: string; readonly storageBucketName?: string } | null;
}

export type UploadedFile = UploadFileDto & { readonly url: string | null };

export function uploadedFileUrl(
  file: Pick<UploadFileDto, 'pathToFileInStorage' | 'storageInfo'> | null | undefined,
): string | null {
  const endpoint = file?.storageInfo?.storageStaticEndpoint;
  const bucket = file?.storageInfo?.storageBucketName;
  const path = file?.pathToFileInStorage;
  return endpoint && bucket && path ? storageFileUrl(endpoint, bucket, path) : null;
}

/** The uploader answers an array of one file or a bare file; no id means nothing was stored. */
export function toUploadedFile(body: unknown): UploadedFile | null {
  const dto = (Array.isArray(body) ? body[0] : body) as UploadFileDto | null | undefined;
  return dto?.id ? { ...dto, url: uploadedFileUrl(dto) } : null;
}
